import { useContext, useEffect, useState } from 'react';
import TrackWrapper from '@/common/TrackWrapper';
import { contentWithNavStyles, TileGrid } from '@/new-cars/new-cars.styles';
import TrimCard from '~/components/new-cars/TrimSection/TrimCard';
import SectionName from '~/constants/new-cars/SectionName';
import { SECTION_VIEW_THRESHOLD } from '~/constants/new-cars/sectionViewThreshold';
import { useDeviceType } from '~/context/common/DeviceContext';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';

const viewEvent = {
  customAttributes: { action: 'viewed', level: 'Trim', section: 'Trim' },
  eventName: 'New Cars'
};

type OwnProps = {
  heading?: string;
};

function TrimSection({ heading }: OwnProps) {
  const {
    activeSection,
    isFirstSection,
    selectedParentModel,
    selectedTrim,
    trims
  } = useContext(ParentModelContext);
  const [expandHighlightsIndex, setExpandHighlightsIndex] = useState<
    number | null
  >(null);

  const { isMobile, isTablet } = useDeviceType();
  const cols = isMobile ? 1 : isTablet ? 2 : 3;

  useEffect(() => {
    setExpandHighlightsIndex(null);
  }, [activeSection]);

  if (trims.data.results.length === 0) return null;

  const { parentModel } = selectedParentModel;
  const defaultHeading =
    isFirstSection(SectionName.Trim) && parentModel
      ? `Select a ${parentModel}`
      : 'Select a Trim';
  const displayHeading = heading ?? defaultHeading;

  return (
    <TrackWrapper
      aria-labelledby="trim-section-heading"
      element="section"
      event={viewEvent}
      threshold={SECTION_VIEW_THRESHOLD}
      trackOnce
      className={contentWithNavStyles}
    >
      <h2 className="text-text-strong t-heading-xl" id="trim-section-heading">
        {displayHeading}
      </h2>
      <TileGrid withNav className="sm:gap-y-0">
        {trims.data.results.map((trim, idx) => (
          <TrimCard
            areHighlightsExpanded={
              expandHighlightsIndex != null &&
              Math.floor(idx / cols) ===
                Math.floor(expandHighlightsIndex / cols)
            }
            index={idx}
            key={trim.title}
            selected={selectedTrim?.trim === trim.next.trim}
            setExpandHighlightsIndex={setExpandHighlightsIndex}
            trim={trim}
          />
        ))}
      </TileGrid>
    </TrackWrapper>
  );
}

export default withErrorBoundary<OwnProps>(
  TrimSection,
  undefined,
  undefined,
  SectionName.Trim
);
